import { useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { selectIsAdmin, selectIsSuperAdmin } from '../../slices/profile';
import NotFound from '../../components/notFound';

const User = () => {
  const isAdmin = useSelector(selectIsAdmin);
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  return isAdmin || isSuperAdmin ? (
    <Outlet />
  ) : (
    <NotFound description="Sorry, you don't have permission to this page!" />
  );
};

export default User;
